import StatsGroupIndex from './StatsGroupIndex';
import StatsGroupCreate from './StatsGroupCreate';
import StatsGroupSettings from './StatsGroupSettings';
import StatsGroupSingle from './StatsGroupSingle';

export default function (app) {

    const settings = StatsGroupSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: settings.title,
        priority: 14,
        items: [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            }
        ],
    });

    StatsGroupIndex(app, settings);

    StatsGroupCreate(app, settings);

    StatsGroupSingle(app, settings);

}